/** Aide contextualisée FR — BT-028 (coquille globale). */

/** @type {Record<string, object>} */
export const helpTopicsFr = {
  accueil: {
    key: "accueil",
    screenLabel: "Accueil public",
    purpose: "Découvrir le portail Phase 1 Shotokan AAMC Black Dragon et le périmètre démo.",
    actions: [
      "Parcourir dojos, instructeurs et documents publics.",
      "Repérer le bandeau [DÉMO] et les emplacements en attente client.",
      "Demander un compte ou se connecter avec les comptes démo.",
    ],
    warning: "Données [DÉMO] — 10 dojos officiels en attente du fichier client.",
    nextStep: "Explorer les dojos ou se connecter en Hanshi pour l'admin.",
  },
  "connected-home": {
    key: "connected-home",
    screenLabel: "Accueil",
    purpose: "Point de départ après connexion — comprendre Shotokan AAMC et démarrer ou reprendre la Formation.",
    actions: [
      "Lire le message de bienvenue adapté à votre rôle.",
      "Commencer ou continuer la Formation guidée.",
      "Explorer l'application via le tableau de bord si vous préférez.",
    ],
    warning: "La Formation n'est jamais obligatoire pour utiliser le logiciel.",
    nextStep: "Ouvrir Formation ou le Tableau de bord.",
  },
  "a-propos": {
    key: "a-propos",
    screenLabel: "À propos",
    purpose: "Comprendre la mission du portail et les limites Phase 1.",
    actions: ["Lire la structure Hanshi / Sensei / dojos.", "Noter l'absence de gestion cours/paiements opérationnels."],
    warning: "Phase 1 — pas de logiciel de présences ni paiements.",
    nextStep: "Retour à l'accueil ou connexion.",
  },
  connexion: {
    key: "connexion",
    screenLabel: "Connexion",
    purpose: "Accéder à un espace selon le rôle démo (admin, sensei, sempai, parent, étudiant).",
    actions: [
      "Utiliser identifiant/mot de passe démo (liste affichée).",
      "Exemple : admin/demo, sensei/demo, etudiant/demo.",
      "Changer de langue FR/EN avant connexion si besoin.",
    ],
    warning: "Comptes locaux Phase 1 uniquement — pas de production.",
    nextStep: "Après connexion, utiliser le menu ou onglets de votre rôle.",
  },
  "change-password": {
    key: "change-password",
    screenLabel: "Changement mot de passe staging",
    purpose: "Remplacer le mot de passe temporaire unique avant d'accéder aux autres zones backend staging.",
    actions: [
      "Saisir le mot de passe temporaire reçu hors bande (jamais affiché publiquement).",
      "Choisir un mot de passe fort (10+ caractères, lettre, chiffre, symbole).",
      "Confirmer le nouveau mot de passe identique.",
    ],
    warning: "Comptes staging temporaires — à remplacer par les courriels officiels.",
    nextStep: "Après succès, accéder à votre espace selon le rôle.",
  },
  "demande-compte": {
    key: "demande-compte",
    screenLabel: "Demande de compte",
    purpose: "Formulaire de demande — enregistrement local démo, pas d'approbation automatique.",
    actions: ["Remplir identité et rôle souhaité.", "Soumettre — stockage local Phase 1."],
    warning: "[DÉMO] — aucune création de compte réelle automatique.",
    nextStep: "Utiliser un compte démo pour tester immédiatement.",
  },
  confidentialite: {
    key: "confidentialite",
    screenLabel: "Politique de confidentialité",
    purpose: "Comprendre le cadre minimal Phase 1 : démo, pas de données réelles, pas de backend sécurisé.",
    actions: [
      "Lire les sections démo / limites / usage futur.",
      "Noter que les coordonnées officielles sont à confirmer.",
    ],
    warning: "Plateforme de démonstration — ne pas présenter comme production avec données réelles.",
    nextStep: "Page Contact pour demander des informations en mode simulation.",
  },
  contact: {
    key: "contact",
    screenLabel: "Contact",
    purpose: "Comprendre comment joindre l'organisation — formulaire mock sans envoi réel.",
    actions: [
      "Consulter le courriel indicatif [DÉMO].",
      "Utiliser le formulaire de simulation (aucun stockage).",
      "Lien vers demande de compte si besoin.",
    ],
    warning: "[DÉMO] — aucun message envoyé à un serveur.",
    nextStep: "Demande de compte ou connexion démo.",
  },
  dojos: {
    key: "dojos",
    screenLabel: "Dojos",
    purpose: "Retrouver et comparer les dojos (objectif : 10 dojos officiels).",
    actions: ["Basculer Cartes / Tableau.", "Rechercher, trier, filtrer.", "Ouvrir une fiche dojo."],
    warning: "Emplacements [DÉMO] — fichier client en attente.",
    nextStep: "Vérifier le Sensei responsable après import client.",
  },
  instructeurs: {
    key: "instructeurs",
    screenLabel: "Instructeurs",
    purpose: "Voir le Hanshi, le leadership reçu et les Sensei — association dojo à confirmer.",
    actions: ["Consulter titres martiaux (aperçu prudent).", "Filtrer par titre ou statut."],
    warning: "Leadership reçu, à confirmer — pas de reconnaissance externe affichée comme officielle.",
    nextStep: "Associer Sensei ↔ dojo quand le fichier client revient.",
  },
  etudiants: {
    key: "etudiants",
    screenLabel: "Étudiants",
    purpose: "Annuaire lecture seule — jeu initial minimal (Marcel Charette, Natalie Lavigne) ; enfant [DÉMO] pour Parent.",
    actions: ["Rechercher un nom.", "Filtrer par dojo."],
    warning: "Grades et groupes « à confirmer » — pas de liste officielle complète.",
    nextStep: "Import massif après réception du fichier client.",
  },
  documents: {
    key: "documents",
    screenLabel: "Documents",
    purpose: "Consulter documents selon visibilité (public, membres, admin).",
    actions: ["Repérer badges de visibilité.", "Protocoles Black Dragon : validation Hanshi requise."],
    warning: "Ne pas publier de protocole sensible sans validation Hanshi.",
    nextStep: "Admin → Shotokan → Documents & Preuves pour les preuves.",
  },
  admin: {
    key: "admin",
    screenLabel: "Administration Hanshi",
    purpose: "Piloter Phase 1 : organisation, activités, progression, Shotokan, administration.",
    actions: [
      "Utiliser les 6 groupes repliables de la sidebar.",
      "Shotokan Black Dragon pour titres et Documents & Preuves.",
      "Import CSV ou import contrôlé documents selon besoin.",
    ],
    checklist: ["Documents & Preuves n'est pas un lien principal — uniquement dans Shotokan."],
    warning: "Phase 1 — pas de paiements ni présences opérationnelles. Données [DÉMO].",
    nextStep: "Présenter la démo client.",
  },
  import: {
    key: "import",
    screenLabel: "Import CSV",
    purpose: "Charger dojos, Sensei et étudiants depuis CSV.",
    actions: ["Coller CSV conforme.", "Aperçu puis confirmer.", "Mode recommandé : officiel + conserver [DÉMO]."],
    warning: "Import Excel direct non développé — convertir depuis le fichier client.",
    nextStep: "Vérifier le tableau de bord Hanshi.",
  },
  shotokan: {
    key: "shotokan",
    screenLabel: "Shotokan Black Dragon",
    purpose: "Module titres, reconnaissances, autorité et Documents & Preuves intégrés.",
    actions: [
      "Consulter vue d'ensemble et sous-menus.",
      "Titres et demandes — référentiel interne.",
      "Documents & Preuves via sous-menu (admin).",
    ],
    warning: "Référentiel interne — à valider selon documents d'autorité fournis. [DÉMO].",
    nextStep: "Vérifier documents requis avant toute décision.",
  },
  "documents-preuves": {
    key: "documents-preuves",
    screenLabel: "Documents & Preuves",
    purpose: "Gérer preuves, dossiers et journal — intégré dans Shotokan (admin).",
    actions: ["Parcourir documents, dossiers, journal.", "Import contrôlé si nécessaire."],
    warning: "Aucune validation officielle automatique — statut initial reçu — validation requise.",
    nextStep: "Import contrôlé pour ajouter un fichier client.",
  },
  "documents-preuves-import": {
    key: "documents-preuves-import",
    screenLabel: "Import contrôlé",
    purpose: "Importer métadonnées document client sans stockage serveur Phase 1.",
    actions: ["Saisir nom fichier.", "Aperçu avant import.", "Confirmer — statut reçu — validation requise imposé."],
    warning: "Fichier non stocké officiellement — backend sécurisé Phase 2+.",
    nextStep: "Vérifier le journal après import.",
  },
  sensei: {
    key: "sensei",
    screenLabel: "Espace Sensei",
    purpose: "Gérer dojo, cours, élèves, progression et Shotokan (droits limités).",
    actions: [
      "Navigation regroupée : Mon dojo, Mes cours, Mes élèves, Progression.",
      "Shotokan Black Dragon pour titres et documents requis.",
      "Documents utiles pour partages dojo.",
    ],
    warning: "[DÉMO] — pas d'attribution officielle de titre sans autorité. Pas d'admin complète.",
    nextStep: "Ouvrir Mes cours ou Mes élèves selon la tâche.",
  },
  "sensei-shotokan": {
    key: "sensei-shotokan",
    screenLabel: "Shotokan Black Dragon (Sensei)",
    purpose: "Consulter titres, soumettre demandes, voir documents requis pour votre dojo.",
    actions: ["Vue d'ensemble.", "Titres et Mes demandes.", "Documents requis."],
    warning: "Référentiel interne — pas de validation externe affichée comme officielle.",
    nextStep: "Compléter les documents requis avant demande.",
  },
  sempai: {
    key: "sempai",
    screenLabel: "Espace Sempai",
    purpose: "Assister classes et consulter élèves — consultation uniquement.",
    actions: [
      "Classes assistées, présences légères, événements.",
      "Progression consultation — observer, pas valider.",
      "Shotokan en lecture — documents requis.",
    ],
    warning: "[DÉMO] — le Sempai ne peut pas valider un grade ni attribuer un titre.",
    nextStep: "Consulter vos classes assistées.",
  },
  "sempai-shotokan": {
    key: "sempai-shotokan",
    screenLabel: "Shotokan Black Dragon (Sempai)",
    purpose: "Parcours titres et documents requis — consultation seulement.",
    actions: ["Vue d'ensemble.", "Parcours titres.", "Documents requis en lecture."],
    warning: "Consultation uniquement — aucune approbation ni validation finale.",
    nextStep: "Remonter au Sensei pour toute décision.",
  },
  "student-space": {
    key: "student-space",
    screenLabel: "Mon espace étudiant",
    purpose: "Vue d'ensemble : dojo, Sensei, accès rapide aux onglets.",
    actions: ["Mes cours, événements, progression, titres, documents.", "7 onglets simples en haut."],
    warning: "[DÉMO] — pas de documents confidentiels ni admin.",
    nextStep: "Ouvrir Mes cours ou Ma progression.",
  },
  "student-classes": {
    key: "student-classes",
    screenLabel: "Mes cours",
    purpose: "Voir les classes auxquelles vous êtes inscrit — horaires démo.",
    actions: ["Consulter la liste.", "Noter les horaires [DÉMO]."],
    warning: "Horaires officiels en attente — données démo.",
    nextStep: "Mes événements pour les séminaires.",
  },
  "student-events": {
    key: "student-events",
    screenLabel: "Mes événements",
    purpose: "Événements à venir liés à votre dojo.",
    actions: ["Parcourir la liste.", "Filtrer si disponible."],
    warning: "[DÉMO] — calendrier démo.",
    nextStep: "Ma progression pour le suivi ceinture.",
  },
  "student-progress": {
    key: "student-progress",
    screenLabel: "Ma progression",
    purpose: "Suivre ceinture et progression — pas de certification officielle Phase 1.",
    actions: ["Voir ceinture actuelle et prochaine étape.", "Consulter examens légers si affichés."],
    warning: "Progression [DÉMO] — pas de certification officielle.",
    nextStep: "Mes titres pour le parcours Shotokan simplifié.",
  },
  "student-titles": {
    key: "student-titles",
    screenLabel: "Mes titres",
    purpose: "Comprendre le parcours titres — pas de demande agressive de haut titre.",
    actions: ["Lire les titres visibles.", "Parler à mon Sensei pour toute question."],
    warning: "Titres martiaux ≠ rôle applicatif. [DÉMO].",
    nextStep: "Retour Mon espace.",
  },
  "student-documents": {
    key: "student-documents",
    screenLabel: "Mes documents",
    purpose: "Documents autorisés pour votre profil — pas d'autorité ni preuves complètes.",
    actions: ["Ouvrir la section Documents filtrée.", "Consulter uniquement ce qui vous est visible."],
    warning: "Aucun document d'autorité confidentiel ici. [DÉMO].",
    nextStep: "Aide ou Mon espace.",
  },
  parent: {
    key: "parent",
    screenLabel: "Espace Parent",
    purpose: "Suivre vos enfants : horaires, événements, progression, documents autorisés.",
    actions: ["7 onglets : Mes enfants, Horaires, Événements, etc.", "Consulter fiches enfants."],
    warning: "Paiements non gérés en Phase 1. [DÉMO]. Pas d'accès Shotokan complet.",
    nextStep: "Horaires ou Progression selon le besoin.",
  },
  "parent-children": {
    key: "parent-children",
    screenLabel: "Mes enfants",
    purpose: "Fiches enfants liées — groupe, ceinture, dojo.",
    actions: ["Lire le résumé par enfant.", "Noter le dojo associé."],
    warning: "Résumé uniquement — paiements non gérés. [DÉMO].",
    nextStep: "Horaires pour le planning.",
  },
  "parent-schedule": {
    key: "parent-schedule",
    screenLabel: "Horaires",
    purpose: "Horaires des cours de vos enfants.",
    actions: ["Consulter classes et créneaux.", "Comparer entre enfants si plusieurs."],
    warning: "Paiements non gérés. Horaires [DÉMO].",
    nextStep: "Événements à venir.",
  },
  "parent-events": {
    key: "parent-events",
    screenLabel: "Événements",
    purpose: "Événements dojo concernant vos enfants.",
    actions: ["Parcourir la liste.", "Noter dates importantes."],
    warning: "Paiements non gérés. [DÉMO].",
    nextStep: "Progression enfant.",
  },
  "parent-progress": {
    key: "parent-progress",
    screenLabel: "Progression",
    purpose: "Progression résumée de l'enfant — ceinture et examens légers.",
    actions: ["Lire le résumé par enfant.", "Pas de validation parent."],
    warning: "Résumé [DÉMO] — paiements d'examen non gérés.",
    nextStep: "Documents autorisés.",
  },
  "parent-documents": {
    key: "parent-documents",
    screenLabel: "Documents",
    purpose: "Documents autorisés pour le parent — pas de dossiers de preuves.",
    actions: ["Consulter documents visibles.", "Contacter le dojo pour plus."],
    warning: "Pas de documents d'autorité. [DÉMO].",
    nextStep: "Communications.",
  },
  "parent-comms": {
    key: "parent-comms",
    screenLabel: "Communications",
    purpose: "Messages simples dojo ↔ parent — consultation démo Phase 1, envoi réel en Phase 2 si requis.",
    actions: ["Lire les communications démo.", "Phase 2+ pour envoi réel."],
    warning: "[DÉMO] — communications non opérationnelles.",
    nextStep: "Retour Mes enfants.",
  },
  formation: {
    key: "formation",
    screenLabel: "Formation",
    purpose: "Parcours guidés Hanshi et Sensei avec progression persistante — plus aperçus statiques pour les autres rôles.",
    actions: [
      "Continuer ma formation ou ouvrir une étape.",
      "Revoir la découverte Shotokan AAMC (7 écrans).",
      "Utiliser Voir → Comprendre → Faire dans chaque étape.",
      "Quitter la formation à tout moment — la progression est sauvegardée.",
    ],
    warning: "Mode formation — actions sensibles en lecture seule ou démo.",
    nextStep: "Continuer le parcours de votre rôle.",
  },
  aide: {
    key: "aide",
    screenLabel: "Centre d'aide",
    purpose: "Page d'accueil de l'aide — le bouton Aide en en-tête reste le flux principal pour l'écran courant.",
    actions: [
      "Ouvrir Formation pour un parcours guidé par rôle.",
      "Utiliser les comptes démo (admin/demo, sensei/demo…) pour explorer les espaces.",
      "Consulter Dojos, Documents et Protocoles pour le périmètre public.",
      "Utiliser le bouton Aide en en-tête pour l'aide contextualisée de l'écran actif.",
    ],
    warning: "[DÉMO] — contenu pédagogique Phase 1, sans module métier supplémentaire.",
    nextStep: "Retourner à votre écran de travail ou ouvrir Formation.",
  },
  "mes-informations": {
    key: "mes-informations",
    screenLabel: "Mon profil",
    purpose: "Résumé du compte connecté — nom affiché, photo de profil et rôle applicatif.",
    actions: [
      "Vérifier le nom et le rôle affichés.",
      "Modifier la photo via l'avatar en en-tête (upload ou caméra si disponible).",
      "Comprendre que les comptes démo ne modifient pas de données officielles.",
    ],
    warning: "[DÉMO] — aucun changement de mot de passe ni de profil officiel en Phase 1.",
    nextStep: "Retourner à Mon espace ou utiliser le sélecteur Mode si disponible.",
  },
};

export const helpFallbackFr = helpTopicsFr.accueil;
